import '@/styles/globals.css'
import { AppProps } from 'next/app'
import { Suspense, useEffect } from 'react'
import { PagesProgressBar as ProgressBar } from 'next-nprogress-bar'
import { Inter } from 'next/font/google'
import cookies from 'js-cookie'
import { UTM_SOURCE_COOKIE_NAME } from '@/constants/cookie'

const inter = Inter({
  subsets: ['latin'],
  weight: ['400', '500', '700'],
  fallback: [
    '-apple-system',
    'system-ui',
    'BlinkMacSystemFont',
    'Helvetica',
    'Arial',
    'Segoe UI',
    'Roboto',
    'sans-serif'
  ]
})

export default function MyApp({ Component, pageProps }: AppProps): JSX.Element {
  useEffect(() => {
    const { searchParams } = new URL(window.location.href.toLowerCase())

    if (searchParams.get('utm_source')) {
      cookies.set(UTM_SOURCE_COOKIE_NAME, searchParams.get('utm_source'), {
        domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
        sameSite: 'lax'
      })
    }
  }, [])

  return (
    <Suspense fallback={null}>
      <div className={inter.className}>
        <Component {...pageProps} />
      </div>
      <ProgressBar
        height="2px"
        color="#1d4ed8"
        options={{ showSpinner: false }}
        shallowRouting
      />
    </Suspense>
  )
}
